import {interventionRole} from '../../../utils/constant';

const clientRoles = [interventionRole.CLIENT];
const managerRoles = [interventionRole.PROJECT_MANAGER, interventionRole.PROJECT_MANAGER_CLIENT];

function computeDepthForSupplyChainDisplay(...interventionArrays) {
  const flattenedInterventions = interventionArrays.flat();
  const interventionsNotInSupplyChain = new Set(flattenedInterventions.map(inter => inter.interventionId));

  return intervention => {
    const {depth, interventionPath} = intervention;
    const path = interventionPath.split('/');
    if (path.length < 2) {
      return 0;
    }

    return path.reduce((currentDepth, element) => (
      interventionsNotInSupplyChain.has(Number(element)) ? currentDepth - 1 : currentDepth
    ), depth);
  };
}

function updateDepth(intervention, computeDepth) {
  return {
    ...intervention,
    depth: computeDepth(intervention)
  };
}

function sortInterventionsForDisplay(interventions) {
  const clientInterventions = [];
  const projectManagerInterventions = [];
  const allOtherInterventions = [];
  const managerInterventionIds = new Set();

  interventions?.forEach(intervention => {
    if (managerRoles.includes(intervention.role)) {
      projectManagerInterventions.push(intervention);
      managerInterventionIds.add(intervention.interventionId);
    } else if (clientRoles.includes(intervention.role)) {
      clientInterventions.push(intervention);
    } else {
      const pathIds = intervention.interventionPath.split('/').map(Number);
      const isChildOfManager = pathIds.some(id => managerInterventionIds.has(id));
      if (isChildOfManager) {
        projectManagerInterventions.push(intervention);
      } else {
        allOtherInterventions.push(intervention);
      }
    }
  });

  return [clientInterventions, projectManagerInterventions, allOtherInterventions];
}

export function arrangeInterventionTreeForDisplay(interventions) {
  const [
    clientInterventions, projectManagerInterventions, allOtherInterventions
  ] = sortInterventionsForDisplay(interventions);

  const computeDepthForClientIntervention = computeDepthForSupplyChainDisplay(projectManagerInterventions, allOtherInterventions);
  const computeDepthForProjectManagerIntervention = computeDepthForSupplyChainDisplay(clientInterventions, allOtherInterventions);
  const computeDepthForOtherIntervention = computeDepthForSupplyChainDisplay(clientInterventions, projectManagerInterventions);

  const updatedClientInterventions = clientInterventions.map(
    intervention => updateDepth(intervention, computeDepthForClientIntervention)
  );
  const updatedProjectManagerInterventions = projectManagerInterventions.map(
    intervention => updateDepth(intervention, computeDepthForProjectManagerIntervention)
  );
  const updatedOtherInterventions = allOtherInterventions.map(
    intervention => updateDepth(intervention, computeDepthForOtherIntervention)
  );

  return [updatedClientInterventions, updatedProjectManagerInterventions, updatedOtherInterventions];
}
